(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["goris-campaigns"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('goris-campaign-hub')) {
  customElements.define('goris-campaign-hub', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      this.track = this.querySelector('.gc-hub__track');
      this.cards = Array.from(this.querySelectorAll('[data-campaign-card]'));
      this.controls = this.querySelector('.gc-hub__controls');
      this.previous = this.querySelector('[data-campaign-direction="-1"]');
      this.next = this.querySelector('[data-campaign-direction="1"]');
      this.counter = this.querySelector('.gc-hub__counter');
      this.toggle = this.querySelector('[data-campaign-toggle]');
      this.toggleLabel = this.toggle?.querySelector('[data-campaign-toggle-label]');
      this.pauseIcon = this.toggle?.querySelector('[data-campaign-pause-icon]');
      this.playIcon = this.toggle?.querySelector('[data-campaign-play-icon]');
      if (!this.track || !this.controls || this.cards.length < 2) return;

      this.autoplayEnabled = this.dataset.autoplay === 'true';
      const seconds = Number(this.dataset.interval);
      this.interval = (Number.isFinite(seconds) && seconds >= 3 ? Math.min(seconds, 12) : 6) * 1000;
      this.userPaused ??= false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.inputModality = null;
      this.ignoreToggleFocus = false;
      this.keyboardFocus = false;
      this.pointerActive = false;
      this.scrolling = false;
      this.autoMoving = false;
      this.inView = false;
      this.updateKeyboardFocus();

      document.addEventListener('pointerdown', () => {
        this.inputModality = 'pointer';
        this.ignoreToggleFocus = false;
        this.updateKeyboardFocus();
        this.syncPlayback();
      }, { capture: true, signal });
      document.addEventListener('keydown', (event) => {
        if (event.metaKey || event.ctrlKey || event.altKey || ['Shift', 'Control', 'Alt', 'Meta'].includes(event.key)) return;
        this.inputModality = 'keyboard';
        this.ignoreToggleFocus = false;
        this.updateKeyboardFocus();
        this.syncPlayback();
      }, { capture: true, signal });
      this.querySelectorAll('[data-campaign-direction]').forEach((button) => {
        button.addEventListener('click', () => this.manualMove(Number(button.dataset.campaignDirection)), { signal });
      });
      this.toggle?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.ignoreToggleFocus = !this.userPaused;
        this.updateKeyboardFocus();
        this.clearTimer();
        this.syncPlayback();
      }, { signal });
      this.track.addEventListener('pointerdown', () => {
        this.pointerActive = true;
        this.syncPlayback();
      }, { signal });
      const endPointer = () => {
        if (!this.pointerActive) return;
        this.pointerActive = false;
        this.syncPlayback();
      };
      window.addEventListener('pointerup', endPointer, { signal });
      window.addEventListener('pointercancel', endPointer, { signal });
      window.addEventListener('blur', endPointer, { signal });
      this.addEventListener('focusin', (event) => {
        this.updateKeyboardFocus();
        this.syncPlayback();
        const card = event.target.closest('[data-campaign-card]');
        if (!card || !this.hasOverflow) return;
        const view = this.track.getBoundingClientRect();
        const bounds = card.getBoundingClientRect();
        if (bounds.left < view.left + 4) this.scrollToPosition(this.track.scrollLeft + bounds.left - view.left - 5, false);
        else if (bounds.right > view.right - 4) this.scrollToPosition(this.track.scrollLeft + bounds.right - view.right + 5, false);
      }, { signal });
      this.addEventListener('focusout', () => {
        queueMicrotask(() => {
          if (signal.aborted) return;
          if (document.activeElement !== this.toggle) this.ignoreToggleFocus = false;
          this.updateKeyboardFocus();
          this.syncPlayback();
        });
      }, { signal });
      this.track.addEventListener('scroll', () => {
        this.scrolling = true;
        this.clearTimer();
        clearTimeout(this.scrollTimer);
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
        this.scrollTimer = setTimeout(() => this.finishScroll(), 180);
      }, { passive: true, signal });
      this.track.addEventListener('scrollend', () => this.finishScroll(), { signal });
      document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
      this.motion.addEventListener('change', () => this.syncPlayback(), { signal });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.cards.forEach((card) => this.resizeObserver.observe(card));
      this.intersectionObserver = new IntersectionObserver((entries) => {
        this.inView = entries[0].isIntersecting;
        this.syncPlayback();
      }, { threshold: [0] });
      this.intersectionObserver.observe(this.track);
      this.dataset.carouselReady = 'true';
      this.update();
    }

    updateKeyboardFocus() {
      const active = document.activeElement;
      const inside = active && this.contains(active);
      const resumeControl = this.ignoreToggleFocus && active === this.toggle;
      const keyboard = this.inputModality === 'keyboard' ||
        (this.inputModality !== 'pointer' && active?.matches?.(':focus-visible'));
      this.keyboardFocus = Boolean(inside && keyboard && !resumeControl);
    }

    canRotate() {
      return this.isConnected && this.autoplayEnabled && !this.userPaused &&
        !this.motion.matches && !document.hidden && this.hasOverflow && this.inView &&
        !this.keyboardFocus && !this.pointerActive;
    }

    clearTimer() {
      clearTimeout(this.timer);
      this.timer = null;
    }

    stopAutoMotion() {
      if (!this.autoMoving) return;
      this.autoMoving = false;
      this.track.scrollTo({ left: this.track.scrollLeft, behavior: 'instant' });
    }

    syncPlayback() {
      if (!this.motion) return;
      const canRotate = this.canRotate();
      if (!canRotate) {
        this.clearTimer();
        this.stopAutoMotion();
      }
      if (this.counter) this.counter.setAttribute('aria-live', canRotate || this.autoMoving ? 'off' : 'polite');
      if (this.toggle) {
        this.toggle.hidden = !this.autoplayEnabled || this.motion.matches || !this.hasOverflow;
        const label = this.userPaused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
        if (label) {
          this.toggle.setAttribute('aria-label', label);
          this.toggle.setAttribute('title', label);
          if (this.toggleLabel) this.toggleLabel.textContent = label;
        }
        this.pauseIcon?.toggleAttribute('hidden', this.userPaused);
        this.playIcon?.toggleAttribute('hidden', !this.userPaused);
      }
      if (!canRotate || this.scrolling || this.timer) return;
      this.timer = setTimeout(() => {
        this.timer = null;
        if (!this.canRotate() || this.scrolling) return;
        this.autoMoving = true;
        this.move(1);
      }, this.interval);
    }

    finishScroll() {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = null;
      this.scrolling = false;
      this.autoMoving = false;
      this.update();
    }

    scrollToPosition(left, animate = true) {
      this.clearTimer();
      clearTimeout(this.scrollTimer);
      this.scrolling = true;
      this.scrollTimer = setTimeout(() => this.finishScroll(), 240);
      this.track.scrollTo({ left, behavior: animate && !this.motion.matches ? 'smooth' : 'instant' });
      this.syncPlayback();
    }

    manualMove(direction) {
      this.stopAutoMotion();
      this.clearTimer();
      this.move(direction);
    }

    move(direction) {
      if (!this.hasOverflow) {
        this.autoMoving = false;
        this.syncPlayback();
        return;
      }
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      if (direction > 0 && this.track.scrollLeft >= maxScroll - 3) {
        this.scrollToPosition(0);
        return;
      }
      if (direction < 0 && this.track.scrollLeft <= 3) {
        this.scrollToPosition(maxScroll);
        return;
      }
      const edge = this.track.getBoundingClientRect().left + 5;
      const offsets = this.cards.map((card) => card.getBoundingClientRect().left - edge);
      let index = offsets.findIndex((offset) => offset >= -3);
      if (index < 0) index = this.cards.length - 1;
      const nextIndex = Math.max(0, Math.min(this.cards.length - 1, index + direction));
      this.scrollToPosition(Math.max(0, Math.min(maxScroll, this.track.scrollLeft + offsets[nextIndex])));
    }

    update() {
      this.hasOverflow = this.track.scrollWidth - this.track.clientWidth > 3;
      this.controls.hidden = !this.hasOverflow;
      if (this.previous) this.previous.disabled = !this.hasOverflow;
      if (this.next) this.next.disabled = !this.hasOverflow;
      this.syncPlayback();
      if (!this.counter) return;
      const view = this.track.getBoundingClientRect();
      const visible = this.cards.map((card, index) => {
        const bounds = card.getBoundingClientRect();
        const overlap = Math.min(bounds.right, view.right) - Math.max(bounds.left, view.left);
        return overlap >= bounds.width * .6 ? index + 1 : null;
      }).filter((index) => index !== null);
      if (!visible.length) return;
      const first = visible[0];
      const last = visible[visible.length - 1];
      const current = first === last ? String(first) : `${first}–${last}`;
      const message = this.counter.dataset.counterTemplate.replace('[current]', current);
      if (this.counter.textContent !== message) this.counter.textContent = message;
    }

    cleanup() {
      this.removeAttribute('data-carousel-ready');
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.clearTimer();
      clearTimeout(this.scrollTimer);
      cancelAnimationFrame(this.frame);
    }

    disconnectedCallback() {
      this.cleanup();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
